import { render, staticRenderFns } from "./Ylms.vue?vue&type=template&id=8066622c&scoped=true&"
import script from "./Ylms.vue?vue&type=script&lang=ts&"
export * from "./Ylms.vue?vue&type=script&lang=ts&"
import style0 from "./Ylms.vue?vue&type=style&index=0&id=8066622c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8066622c",
  null
  
)

export default component.exports